/* "Pit lane" desktop navigation (snippets/desktop-mega.liquid). header.js still opens and closes
   the mega panels ([data-mega-menu][data-active]). This file adds:
   - rail previews: hovering or focusing a rail link shows its pane on the right;
   - Escape closes an open mega panel and returns focus to its trigger;
   - the search panel: the desktop search icon opens it (the icon stays a link to /search
     without JS), live results from Shopify's predictive search (/search/suggest.json), Escape,
     the close button and outside clicks close it, and opening a mega panel closes it. */
(function () {
  const header = document.querySelector('[data-header]');
  if (!header) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Rail previews ---------- */
  header.querySelectorAll('[data-dmega]').forEach(function (mega) {
    const tabs = Array.from(mega.querySelectorAll('[data-dmega-tab]'));
    const panes = Array.from(mega.querySelectorAll('[data-dmega-pane]'));
    if (!tabs.length) return;
    // Feature panels (Riders): the other tabs' photos are lazy and hidden, so they would only start loading when a tab
    // is first shown. Start them the moment the panel opens, so switching tabs is instant.
    if (mega.classList.contains('dmega--feature')) {
      const warm = function () {
        mega.querySelectorAll('[data-dmega-pane] img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      };
      new MutationObserver(function () { if (mega.hasAttribute('data-active')) warm(); })
        .observe(mega, { attributes: true, attributeFilter: ['data-active'] });
    }
    let timer = null;
    function activate(i) {
      tabs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      panes.forEach(function (p, k) {
        const on = k === i;
        p.hidden = !on;
        p.classList.toggle('is-active', on);
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { activate(i); }, 70);
      });
      tab.addEventListener('mouseleave', function () { clearTimeout(timer); });
      tab.addEventListener('focus', function () { activate(i); });
    });
  });

  /* ---------- Tab order ----------
     The panels render after the nav list and the header icons, so the natural Tab order skips
     them. Bridge it: trigger → its open panel → the next nav link (Shift+Tab from the panel's
     first item goes back to the trigger). */
  function focusables(el) {
    return Array.from(el.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (x) { return !x.closest('[hidden]'); });
  }

  function bridge(panel, before, after, isOpen) {
    before.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || e.shiftKey || !isOpen()) return;
      const first = focusables(panel)[0];
      if (!first) return;
      e.preventDefault();
      first.focus();
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      const items = focusables(panel);
      if (!items.length) return;
      if (e.shiftKey && document.activeElement === items[0]) {
        e.preventDefault();
        before.focus();
      } else if (!e.shiftKey && document.activeElement === items[items.length - 1]) {
        const next = after();
        if (!next) return;
        e.preventDefault();
        next.focus();
      }
    });
  }

  const endLinks = function () { return focusables(header.querySelector('.header__end') || header); };
  header.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
    const panel = header.querySelector('[data-mega-menu="' + trigger.getAttribute('data-mega-trigger') + '"]');
    if (!panel) return;
    bridge(panel, trigger, function () {
      const li = trigger.closest('li');
      const nextLi = li && li.nextElementSibling;
      return (nextLi && nextLi.querySelector('a, button')) || endLinks()[0];
    }, function () { return panel.hasAttribute('data-active'); });
  });

  /* ---------- Escape closes a mega panel ----------
     Capture phase, so this runs before header.js closes every panel (it would leave focus on a
     hidden link). */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const open = header.querySelector('[data-mega-menu][data-active]');
    if (!open) return;
    const trigger = header.querySelector('[data-mega-trigger="' + open.getAttribute('data-mega-menu') + '"]');
    // Focus first: in hover mode header.js reopens a panel when its trigger gains focus.
    if (trigger && open.contains(document.activeElement)) trigger.focus();
    open.removeAttribute('data-active');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.querySelector('.header__nav-chevron')?.classList.remove('header__nav-chevron--active');
    }
  }, true);

  /* ---------- Search panel ---------- */
  const panel = header.querySelector('[data-dsearch]');
  const icon = header.querySelector('.header__action--search-desktop');
  if (!panel || !icon) return;
  const input = panel.querySelector('[data-dsearch-input]');
  const results = panel.querySelector('[data-dsearch-results]');
  const start = panel.querySelector('[data-dsearch-start]');
  const status = panel.querySelector('[data-dsearch-status]');
  const closeBtn = panel.querySelector('[data-dsearch-close]');
  let controller = null;
  let debounce = null;

  icon.setAttribute('aria-controls', 'dsearch');
  icon.setAttribute('aria-expanded', 'false');
  icon.setAttribute('role', 'button');
  bridge(panel, icon, function () {
    const links = endLinks();
    return links[links.indexOf(icon) + 1] || null;
  }, function () { return !panel.hidden; });

  function closeMegas() {
    header.querySelectorAll('[data-mega-menu][data-active]').forEach(function (m) { m.removeAttribute('data-active'); });
    header.querySelectorAll('[data-mega-trigger][aria-expanded="true"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }

  function openSearch() {
    closeMegas();
    panel.hidden = false;
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    icon.setAttribute('aria-expanded', 'true');
    input.focus();
    input.select();
  }

  function closeSearch(focusIcon) {
    if (panel.hidden) return;
    panel.classList.remove('is-open');
    panel.hidden = true;
    icon.setAttribute('aria-expanded', 'false');
    if (focusIcon) icon.focus();
  }

  icon.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    if (panel.hidden) openSearch(); else closeSearch(true);
  });
  icon.addEventListener('keydown', function (e) {
    if (e.key !== ' ') return; // role="button": Space activates it too
    e.preventDefault();
    icon.click();
  });
  closeBtn.addEventListener('click', function () { closeSearch(true); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) closeSearch(true);
  });
  document.addEventListener('click', function (e) {
    if (panel.hidden) return;
    if (panel.contains(e.target) || icon.contains(e.target)) return;
    closeSearch(false);
  });
  // A mega panel opening (hover or click) closes the search panel.
  new MutationObserver(function () {
    if (!panel.hidden && header.querySelector('[data-mega-menu][data-active]')) closeSearch(false);
  }).observe(header, { subtree: true, attributes: true, attributeFilter: ['data-active'] });

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function money(v) {
    const n = typeof v === 'string' ? parseFloat(v) : v;
    if (!isFinite(n)) return '';
    try {
      const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(n);
    } catch (err) { return '$' + n.toFixed(2); }
  }

  function render(q, data) {
    const r = (data && data.resources && data.resources.results) || {};
    const products = r.products || [];
    const collections = r.collections || [];
    const pages = r.pages || [];
    const total = products.length + collections.length + pages.length;
    const all = root + 'search?q=' + encodeURIComponent(q);
    status.textContent = total ? total + ' suggestions for ' + q : 'No suggestions for ' + q;
    if (!total) {
      results.innerHTML = '<p class="dsearch__empty">No matches for “' + esc(q) + '”. <a href="' + all + '">Search everything</a></p>';
      return;
    }
    let html = '';
    if (products.length) {
      html += '<div class="dsearch__group dsearch__group--products"><p class="dmega__label">Products</p><ul class="dsearch__products" role="list">' +
        products.map(function (p) {
          const img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          return '<li><a class="dsearch__product" href="' + esc(p.url) + '">' +
            '<span class="dsearch__product-media">' + (img ? '<img src="' + esc(sized(img, 240)) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</span>' +
            '<span class="dsearch__product-title">' + esc(p.title) + '</span>' +
            (p.price ? '<span class="dsearch__product-price">' + esc(money(p.price)) + '</span>' : '') +
            '</a></li>';
        }).join('') + '</ul></div>';
    }
    const links = collections.map(function (c) { return { t: c.title, u: c.url, k: 'Collection' }; })
      .concat(pages.map(function (p) { return { t: p.title, u: p.url, k: 'Page' }; }));
    if (links.length) {
      html += '<div class="dsearch__group"><p class="dmega__label">Collections &amp; pages</p><ul class="dsearch__links" role="list">' +
        links.map(function (l) {
          return '<li><a href="' + esc(l.u) + '"><span>' + esc(l.t) + '</span><span class="dsearch__kind">' + l.k + '</span></a></li>';
        }).join('') + '</ul></div>';
    }
    html += '<a class="dmega__all dsearch__all" href="' + all + '">See all results for “' + esc(q) + '”<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
    results.innerHTML = html;
  }

  input.addEventListener('input', function () {
    const q = input.value.trim();
    clearTimeout(debounce);
    if (controller) controller.abort();
    if (q.length < 2) {
      results.hidden = true;
      start.hidden = false;
      status.textContent = '';
      return;
    }
    debounce = setTimeout(function () {
      controller = new AbortController();
      const url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (input.value.trim() !== q) return;
          start.hidden = true;
          results.hidden = false;
          render(q, data);
        })
        .catch(function () { /* aborted or offline: keep the last results */ });
    }, 180);
  });
})();
